import styled from 'styled-components';
import { createGradientOrSolid } from 'utils/index';
import { breakpoints } from 'styles/breakpoints';

type GhostBundleProps = {
  backgroundSrc: any;
  backgroundColor: any;
};

export const StyledGhostBundle = styled.div<GhostBundleProps>`
  width: 100%;
  max-width: 400px;
  height: 82px;
  position: relative;
  font-family: var(--font-family), Arial;
  font-weight: 950;
  background: var(--bundle-border-color);
  border-radius: 7px;
  padding: 1px;

  .container {
    background: ${({ backgroundSrc, backgroundColor }: any) =>
      backgroundSrc
        ? `url("${backgroundSrc}")`
        : createGradientOrSolid(backgroundColor)};
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center;
    width: 100%;
    height: 100%;
    border-radius: 6px;
    display: flex;
    padding: 4px 3px 4px 3px;

    .ghost-emblem {
      position: absolute;
      top: 0;
      left: 0;
      width: 56px;
      height: 56px;

      &--badge {
        width: 56px;
        height: 56px;
        object-fit: contain;
      }
    }

    .main-product--image {
      width: 52px;
      height: 52px;
      min-width: 52px;
      min-height: 52px;
      margin-right: 2px;
      margin-top: 2px;

      .image {
        width: 100%;
        height: auto;
        object-fit: contain;
      }
    }

    .products {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .top-container {
        width: 100%;

        .main-product {
          display: flex;
          justify-content: space-between;
          align-items: start;
          //width: 100%;

          &--amount {
            position: relative;
            z-index: 1;
            display: flex;
            margin-right: 3px;
            width: calc(100% - 130px);

            &-price {
              font-size: 24px;
              text-align: center;
              font-style: normal;
              font-weight: 950;
              line-height: normal;
              background: linear-gradient(
                180deg,
                #ffdf36 21.16%,
                #ffeeb4 51%,
                #ffb800 77.94%
              );
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              position: relative;

              &::after {
                content: attr(data-text);
                left: 0;
                top: 0;
                z-index: -1;
                position: absolute;
                color: #a64fc9;
                -webkit-text-stroke: 5px #a700c7;
                text-stroke: 5px #a700c7;
                -webkit-text-fill-color: transparent;
              }
            }
          }

          &--stroked {
            color: #fff;
            text-shadow: 0 1px 1px rgba(0, 0, 0, 0.6);
            font-size: 12px;
            font-style: normal;
            font-weight: 950;
            line-height: normal;
            text-decoration: line-through;
            text-decoration-color: #d70000;
            width: fit-content;
            height: 14px;
          }
        }

        .price-container {
          margin-left: auto;
          height: 24px;
          width: 86px;
          position: absolute;
          right: 28px;
          top: 50%;
          transform: translateY(-50%);

          .price {
            border: 1px solid #24e93b;
            width: 86px;
            border-radius: 16px;
            height: 24px;
            display: flex;
            align-items: center;
            position: relative;
            font-size: inherit;
            box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.8);

            &:before {
              content: '';
              width: 78px;
              height: 12px;
              background: rgba(255, 255, 255, 0.4);
              position: absolute;
              border-radius: 16px;
              top: 1px;
            }

            .totalPrice {
              padding: 0 5px;

              .stroked {
                font-size: 8px;
                font-style: normal;
                font-weight: 950;
                line-height: normal;
                margin-left: 2px;
                text-decoration-thickness: 1px;
                text-shadow: 0 1px 1px rgba(0, 0, 0, 0.6);
              }

              .final-price {
                text-shadow: -1px -1px 0 #0b7d00, 1px -1px 0 #0b7d00,
                  -1px 1px 0 #0b7d00, 1px 1px 0 #0b7d00;
                font-weight: 950;
              }
            }
          }
        }
      }

      .sub-products {
        display: flex;

        .sub-product {
          display: flex;
          align-items: center;
          margin-right: 8px;

          &:last-child {
            margin-right: 0;
          }

          &--image {
            width: 20px;
            height: auto;
            object-fit: contain;
            margin-right: 4px;
          }

          &--amount {
            font-size: 12px;
            font-style: normal;
            font-weight: 950;
            line-height: normal;
            text-shadow: 0 -1px 0.2px #8a31d1, 0 1px 0.2px #8a31d1,
              -1px 0 0.2px #8a31d1, 1px 0 0.2px #8a31d1, 1px 1px 0.2px #8a31d1,
              -1px -1px 0.2px #8a31d1, -1px 1px 0.2px #8a31d1,
              1px -1px 0.2px #8a31d1;
          }
        }
      }
    }
  }

  @media only screen and (min-width: ${breakpoints.desktop}) {
    .container {
      .main-product--image {
        width: 60px;
        height: 60px;
        min-width: 60px;
        min-height: 60px;
        margin-right: 7px;
      }

      .products {
        .top-container {
          .main-product {
            &--amount {
              width: calc(100% - 150px);
            }

            &--stroked {
              font-size: 14px;
              height: 18px;
            }
          }

          .price-container {
            height: 28px;
            width: 112px;
            right: 22px;

            .price {
              height: 28px;
              width: 112px;
              border-radius: 18px;

              &:before {
                content: '';
                width: 103px;
                height: 14px;
                border-radius: 18px;
              }

              .totalPrice {
                .stroked {
                  font-size: 9px;
                  margin-left: 3px;
                }
              }
            }
          }
        }
      }
    }
  }
`;
